import { CustomFilterField, CustomFilterType, CustomFilterOperator } from "../Models/CustomFilterModels";

export enum RouteFilter {
    All
}

export enum RouteOrder {
    None,
    RouteCode,
    Status,
    LegalType,
    AdminArea,
    Priority
}
